<div class="parking-right-page p-4">
    <jjames-card>
        <!-- Header -->
        <div class="flex items-center gap-2 mb-6">
            <mat-icon class="text-2xl text-blue-600">verified_user</mat-icon>
            <h2 class="text-xl font-semibold">{{ 'parkingRight.title' | translate }}</h2>
        </div>

        <!-- Parking Space Selection -->
        <div class="mb-6">
            <h3 class="text-lg font-medium mb-3">{{ 'parkingRight.selectSpace' | translate }}</h3>
            <form [formGroup]="form">
                <mat-form-field appearance="fill" class="w-full max-w-md">
                    <mat-label>{{ 'parkingRight.spaceLabel' | translate }}</mat-label>
                    <mat-select formControlName="parkingSpaceId">
                        <mat-option value="">{{ 'parkingRight.selectSpaceOption' | translate }}</mat-option>
                        @for (space of parkingSpaces(); track space.id) {
                        <mat-option [value]="space.id">
                            <div class="flex items-center gap-2">
                                <mat-icon class="text-base text-blue-600" fontIcon="local_parkin"></mat-icon>
                                <span>{{ space.name }}</span>
                            </div>
                        </mat-option>
                        }
                    </mat-select>
                    @if (isLoadingSpaces()) {
                    <mat-hint>{{ 'parkingRight.loadingSpaces' | translate }}</mat-hint>
                    }
                </mat-form-field>
            </form>
        </div>

        <!-- Parking Rights List -->
        @if (selectedParkingSpace()) {
        <app-parking-right-list [allParkingSpaces]="parkingSpaces()" [parkingSpace]="selectedParkingSpace()"
            [allParkingTypes]="allParkingTypes()" [parkingTypeOptions]="parkingTypeOptions()"
            [isLoadingTypes]="isLoadingTypes()">
        </app-parking-right-list>
        } @else {
        <div class="bg-gray-50 rounded-lg p-8 text-center">
            <mat-icon class="text-6xl text-gray-400 mb-4">verified_user</mat-icon>
            <p class="text-gray-600">{{ 'parkingRight.selectSpacePrompt' | translate }}</p>
        </div>
        }
    </jjames-card>
</div>